import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useToggleStyles = createUseStyles({
  toggleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 0.5rem',
    marginTop: '1rem',
    minHeight: 40,
    minWidth: 200,
    backgroundColor: colors.gray100,
    cursor: 'pointer',

    '& > .toggle-label': {
      fontWeight: 'bold',
      color: colors.gray600,
      fontSize: 12,
      margin: '0.5rem 0'
    },

    '&.disabled': {
      opacity: 0.4,
      pointerEvents: 'none'
    },

    '&.bordered': {
      backgroundColor: '#fff',
      borderRadius: '4px',
      border: `1px solid ${colors.gray200}`
    },

    '&.checked > .toggle-label': {
      color: colors.primary1
    }
  },
  toggle: {
    position: 'relative',
    display: 'inline-block',
    marginLeft: '1rem',
    minWidth: 40,
    maxWidth: 40,
    height: 20,
    '& > .toggle-slider': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: 20,
      backgroundColor: colors.gray300,
      '-webkit-transition': '.4s',
      transition: '.4s',
      '&::before': {
        content: '""',
        position: 'absolute',
        height: 16,
        width: 16,
        left: 2,
        bottom: 2,
        borderRadius: '50%',
        backgroundColor: '#fff',
        '-webkit-transition': '.4s',
        transition: '.4s'
      }
    },
    '& > input': {
      opacity: 0,
      width: 30,
      height: 30
    },
    '& > input:checked + .toggle-slider': {
      backgroundColor: colors.primary1
    },
    '& > input:checked + .toggle-slider:before': {
      '-webkit-transform': 'translateX(20px)',
      '-ms-transform': 'translateX(20px)',
      transform: 'translateX(20px)'
    }
  }
})

export { useToggleStyles }
